import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { SERVICES } from "@/data/services";
import { BAIRROS } from "@/data/bairros";
import { serviceUrl, bairroUrl } from "@/lib/routes";

export const ServiceGrid = ({ exclude }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="service-grid">
    {SERVICES.filter((s) => s.slug !== exclude).map((s) => (
      <Link key={s.slug} to={serviceUrl(s)} className="group bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-shadow" data-testid={`service-card-${s.slug}`}>
        <div className="relative h-44 overflow-hidden">
          <img src={s.image} alt={`${s.nome} em Guarulhos - técnico profissional`} loading="lazy" width="480" height="320" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <span className="absolute top-3 left-3 bg-brand-red text-white text-[11px] font-heading font-bold uppercase px-3 py-1 rounded-full">24 horas</span>
        </div>
        <div className="p-5">
          <h3 className="font-heading font-bold text-lg text-brand-dark group-hover:text-brand-red transition-colors">{s.nome}</h3>
          <p className="text-gray-500 text-sm mt-2 line-clamp-2">{s.resumo}</p>
          <span className="inline-flex items-center gap-1 text-brand-red font-heading font-bold text-sm mt-4">
            Ver detalhes <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
          </span>
        </div>
      </Link>
    ))}
  </div>
);

export const BairroGrid = ({ exclude }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="bairro-grid">
    {BAIRROS.filter((b) => b.slug !== exclude).map((b) => (
      <Link key={b.slug} to={bairroUrl(b)} className="flex items-center gap-2 bg-white border border-gray-100 rounded-lg px-4 py-3 shadow-sm hover:shadow-md hover:border-brand-red/40 transition-all group" data-testid={`bairro-card-${b.slug}`}>
        <MapPin size={16} className="text-brand-red shrink-0" />
        <span className="text-sm font-medium text-brand-dark group-hover:text-brand-red transition-colors">{b.nome}</span>
      </Link>
    ))}
  </div>
);
